export default {
  velt: {
    openPanel: 'Abrir panel de comentarios',
    closePanel: 'Cerrar panel de comentarios',
    panel: 'Panel de comentarios',
    tabs: 'Pestañas del panel de comentarios',
    comments: 'Comentarios',
    settings: 'Ajustes y permisos',
    dragOrTapComment: 'Arrastra para añadir un comentario, o toca para ver los comentarios',
    assignComment: 'Asignar comentario',
    markAsUnread: 'Marcar como no leído',
    markAsRead: 'Marcar como leído',
    unsubscribe: 'Cancelar suscripción',
    subscribe: 'Suscribirse',
    deleteThread: 'Eliminar hilo',
    editComment: 'Editar comentario',
    emptyPlaceholder: 'Da feedback, haz una pregunta o deja una nota para los miembros de tu equipo',
    searchPlaceholder: 'Buscar comentarios',
    commentPlaceholder: 'Comentar en {page}',
    replyPlaceholder: 'Responder....',
    filterPages: 'Páginas',
    filterAuthor: 'Autor',
    filterTagged: 'Etiquetados',
    statusOpen: 'Abierto',
    statusResolved: 'Resuelto',
    anonymous: 'Anónimo',
    settingsPanel: {
      title: '¿Quién puede comentar?',
      everyoneLabel: 'Todos',
      restrictedLabel: 'Solo colaboradores invitados',
      emailsLabel: 'Correos electrónicos',
      emailsPlaceholder: 'Añade un correo y pulsa Intro',
    },
  },
}
